import { render, staticRenderFns } from "./MaintenancesList.vue?vue&type=template&id=9708d7a4&scoped=true&"
import script from "./MaintenancesList.vue?vue&type=script&lang=js&"
export * from "./MaintenancesList.vue?vue&type=script&lang=js&"
import style0 from "./MaintenancesList.vue?vue&type=style&index=0&id=9708d7a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9708d7a4",
  null
  
)

component.options.__file = "MaintenancesList.vue"
export default component.exports